// extracted by mini-css-extract-plugin
export default {"container":"wikiList_container__n7a8d"};